module.exports = __webpack_public_path__ + "static/media/aAdams.b87abc7e.jpeg";